module.exports = __webpack_public_path__ + "static/media/NoPending.24456b67.svg";